import {
  APPLE_CODE,
  AUTH_TOKEN,
  CODE_COUNTDOWN_STARTED_AT,
  CODE_TRIES_LEFT,
  DISCOVERY_CACHE,
  FIREBASE_TOKEN,
  GOOGLE_TOKEN,
  INTERNAL_ANALYTICS,
  SHOWN_PROFILE_PROGRESS,
  SIGN_UP_INFO,
  USER_INFO_STEP,
} from './serve/consts';
import {remove} from './serve/localStorage';

const KEYS_TO_REMOVE = [
  AUTH_TOKEN,
  GOOGLE_TOKEN,
  APPLE_CODE,
  INTERNAL_ANALYTICS,
  SHOWN_PROFILE_PROGRESS,
  SIGN_UP_INFO,
  DISCOVERY_CACHE,
  FIREBASE_TOKEN,
  CODE_COUNTDOWN_STARTED_AT,
  CODE_TRIES_LEFT,
  USER_INFO_STEP,
];

export function clearLocalStorage(): void {
  for (const key of KEYS_TO_REMOVE) {
    remove(key);
  }
}
